import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { formatPrice } from 'services/formatter';

import styles from './CartProductPrice.module.scss';

export default function CartProductPrice({
  classes,
  crossedOutPrice,
  price,
}: CartProductPriceType): JSX.Element {
  const { t } = useTranslation();
  const hasCrossedOutPrice = crossedOutPrice && +crossedOutPrice > 0;
  const isFree = +price === 0;
  const formattedPrice = !isFree ? formatPrice(price) : t('LABEL_FREE');

  return (
    <>
      {hasCrossedOutPrice && (
        <span
          className={classNames(
            styles.crossedOutPrice,
            classes?.crossedOutPrice
          )}
        >
          {formatPrice(crossedOutPrice)}
        </span>
      )}
      <span
        className={classNames(styles.price, classes?.price, {
          [styles.highlighted]: hasCrossedOutPrice || isFree,
        })}
      >
        {formattedPrice}
      </span>
    </>
  );
}

type CartProductPriceType = {
  classes?: CartProductPriceClassesType;
  crossedOutPrice?: string;
  price: string;
};

type CartProductPriceClassesType = {
  crossedOutPrice?: string;
  price?: string;
};
